import React, { useState } from 'react';
import PropTypes from 'prop-types';

const DEFAULT_VALUES = {
  background_color: '#313437',
  primary_color: '#ffffff',
  primary_color_accent: '#ffffff',
  primary_color_neutral: '#ffffff',
  links_color: '#313437',
};

export default function GarageStyles({ cellValue, onFocusOut }) {
  const [value, setValue] = useState({ ...DEFAULT_VALUES, ...cellValue });

  const onChangeInput = (name) => (e) => {
    const newValue = { ...value, [name]: e.target.value };
    setValue(newValue);
    
    // Create synthetic event with updated value
    const syntheticEvent = {
      target: { value: newValue, name },
    };
    onFocusOut(syntheticEvent);
  };

  return (
    <div>
      <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
        Primary colour:
        <input
          placeholder="#ffffff"
          name="primary_color"
          type="text"
          onChange={onChangeInput('primary_color')}
          value={value.primary_color}
          style={{ marginLeft: '10px', width: '100px' }}
        />
      </label>

      <div style={{ opacity: 0.6 }}>
        <label style={{ display: 'block', marginBottom: '5px' }}>
          Background colour:
          <input
            placeholder="#313437"
            name="background_color"
            type="text"
            onChange={onChangeInput('background_color')}
            value={value.background_color}
            style={{ marginLeft: '10px', width: '100px' }}
          />
        </label>
        
        <label style={{ display: 'block', marginBottom: '5px' }}>
          Primary colour accent:
          <input
            placeholder="#ffffff"
            name="primary_color_accent"
            type="text"
            onChange={onChangeInput('primary_color_accent')}
            value={value.primary_color_accent}
            style={{ marginLeft: '10px', width: '100px' }}
          />
        </label>
        
        <label style={{ display: 'block', marginBottom: '5px' }}>
          Primary colour neutral:
          <input
            placeholder="#ffffff"
            name="primary_color_neutral"
            type="text"
            onChange={onChangeInput('primary_color_neutral')}
            value={value.primary_color_neutral}
            style={{ marginLeft: '10px', width: '100px' }}
          />
        </label>
        
        <label style={{ display: 'block', marginBottom: '5px' }}>
          Links colour:
          <input
            placeholder="#313437"
            name="links_color"
            type="text"
            onChange={onChangeInput('links_color')}
            value={value.links_color}
            style={{ marginLeft: '10px', width: '100px' }}
          />
        </label>
      </div>
    </div>
  );
}

GarageStyles.propTypes = {
  cellValue: PropTypes.object,
  onFocusOut: PropTypes.func,
};

GarageStyles.defaultProps = {
  cellValue: {},
  onFocusOut: () => {},
};
